import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    onClick(event) {
        event.target.classList.toggle('active');
        document.dispatchEvent(new CustomEvent("calendarChange"));
    }
}
